export interface PublicPageMetadata {
  title: string;
  description: string;
  image: string;
  canonicalUrl: string;
}

export const PUBLIC_METADATA = {
  ORIGIN: 'https://nexotcg.com',
  DEFAULT_IMAGE: '/assets/email/nexo-logo.png',
  DESCRIPTION:
    'Compre e venda cartas de TCG, encontre impressões e organize seu deck na Nexo.',
  TITLE: 'NexoTCG',
  CACHE_MS: 300_000,
  TIMEOUT_MS: 3000,
  ENDPOINT: '/api/public/metadata',
  CONFIG_PATH: '/public-metadata-config.json',
} as const;
